import processEvent from 'analytics/processEvent';
import anaConsts from 'analytics/constants';

const firedIntentions = new Set();

export function trackToolTriggered(intentions) {
    if (!Array.isArray(intentions) || intentions.length === 0) {
        return;
    }

    const newIntentions = intentions.filter(intention => typeof intention === 'string' && intention && !firedIntentions.has(intention));

    if (newIntentions.length === 0) {
        return;
    }

    newIntentions.forEach(intention => firedIntentions.add(intention));

    processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
        data: {
            pageName: anaConsts.SUPER_CHAT.SUPERCHAT_LANDING,
            actionInfo: `${anaConsts.SUPER_CHAT.SUPERCHAT_TOOL_TRIGGERED}${newIntentions.join(',')}`
        }
    });
}

export function resetToolTriggeredCache() {
    firedIntentions.clear();
}
